import loadable from "utils/loadable";

export const HalamanLoginAdmin = loadable(() => import("./index"));
export const SignInCard = loadable(() => import("./SignInCard"));
